export const SET_CURRENT_LAYOUT = 'VIDEO_CROP/SET_CURRENT_LAYOUT'
export const SET_CURRENT_SNAPGRID = 'VIDEO_CROP/SET_CURRENT_SNAPGRID'
export const SET_SCALE_VALUE = 'VIDEO_CROP/SET_SCALE_VALUE'
export const SET_LIBRARY_ASSET = 'VIDEO_CROP/SET_LIBRARY_ASSET'
